import StSystemNavigationDrawer from '@/language/pt/StSystemNavigationDrawer';
import StCompanySelection from '@/language/pt/StCompanySelection';
import LoginView from '@/language/pt/LoginView';
import Layout from '@/language/pt/Layout';
import ErrorStatus from '@/language/pt/ErrorStatus';
import AccessView from '@/language/pt/AccessView';
import UniversesView from '@/language/pt/UniversesView';
import AccessModal from '@/language/pt/components/AccessModal.js';
import UniversesModal from '@/language/pt/components/UniversesModal.js';
import LayoutContent from '@/language/pt/components/LayoutContent.js';
import FormModal from '@/language/pt/mixins/form-modal.js';
import DeleteUniverseModal from '@/language/pt/components/DeleteUniverseModal.js';

export default {
  StSystemNavigationDrawer,
  StCompanySelection,
  LoginView,
  AccessView,
  UniversesView,
  Layout,
  ErrorStatus,
  AccessModal,
  UniversesModal,
  LayoutContent,
  FormModal,
  DeleteUniverseModal,
};
